import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './Reviews.scss';

const reviews = [
  {
    name: 'Katrin Neubauer',
    subtitle: 'Regelmäßige Büroreinigung',
    text: 'Wir arbeiten seit mehreren Monaten mit diesem Reinigungsteam zusammen und sind rundum zufrieden. Die Mitarbeiter sind pünktlich, freundlich und achten auf jedes Detail. Unser Büro sieht immer gepflegt aus – genau so, wie man es sich wünscht. Absolute Empfehlung!',
    avatar: 'https://randomuser.me/api/portraits/women/65.jpg',
  },
  {
    name: 'Lukas Steiner',
    subtitle: 'Treppenhausreinigung',
    text: 'Die Firma reinigt unser Mehrfamilienhaus seit Anfang des Jahres. Die Arbeit wird zuverlässig, schnell und gründlich erledigt. Besonders schätze ich die Flexibilität, wenn kurzfristig etwas geändert werden muss. Sehr professionell!',
    avatar: 'https://randomuser.me/api/portraits/men/46.jpg',
  },
  {
    name: 'Annemarie Vogt',
    subtitle: 'Wohnungsreinigung',
    text: 'Ich bin wirklich begeistert! Nach der Reinigung war meine Wohnung wie neu – alles sauber, frisch und ordentlich. Das Team arbeitet diskret und respektvoll. So eine Qualität findet man selten.',
    avatar: 'https://randomuser.me/api/portraits/women/32.jpg',
  },
  {
    name: 'Jonas Feldkamp',
    subtitle: 'Hausmeisterdienste',
    text: 'Seit wir diesen Service nutzen, läuft in unserem Gebäude alles reibungslos. Kleine Reparaturen, Kontrolle der Anlagen, Sauberkeit – alles perfekt organisiert. Man merkt, dass hier mitgedacht wird.',
    avatar: 'https://randomuser.me/api/portraits/men/55.jpg',
  },
  {
    name: 'Claudia Brenner',
    subtitle: 'Grundreinigung nach Renovierung',
    text: 'Nach einer Renovierung war meine Wohnung voller Staub. Das Team kam pünktlich und hat in wenigen Stunden alles blitzsauber gemacht – selbst die schwer erreichbaren Stellen. Ich bin beeindruckt!',
    avatar: 'https://randomuser.me/api/portraits/women/29.jpg',
  },
  {
    name: 'Sebastian Kühl',
    subtitle: 'Reinigung von Monteurunterkünften',
    text: 'Wir beauftragen die Firma regelmäßig für unsere Monteurwohnungen. Alles läuft zuverlässig und unkompliziert. Die Zimmer sind immer hygienisch sauber und bereit für neue Gäste. Super Service!',
    avatar: 'https://randomuser.me/api/portraits/men/74.jpg',
  },
];

const Reviews = () => {
  return (
    <section
      className='reviews'
      id='reviews'>
      <div className='container'>
        <h2>
          Kundenbewertungen über unsere <br /> Reinigungsleistungen
        </h2>

        <div className='reviews__nav'>
          <button className='reviews__prev'>←</button>
          <button className='reviews__next'>→</button>
        </div>

        <Swiper
          modules={[Navigation]}
          navigation={{
            nextEl: '.reviews__next',
            prevEl: '.reviews__prev',
          }}
          spaceBetween={40}
          speed={700}
          loop={true}
          breakpoints={{
            0: { slidesPerView: 1, spaceBetween: 24 },
            768: { slidesPerView: 1.5, spaceBetween: 32 },
            1024: { slidesPerView: 2, spaceBetween: 40 },
          }}
          className='reviews__slider'>
          {reviews.map((item, index) => (
            <SwiperSlide key={index}>
              <div className='review-card'>
                <div className='review-card__avatar'>
                  <img
                    src={item.avatar}
                    alt={item.name}
                  />
                </div>
                <div className='review-card__info'>
                  <h3>{item.name}</h3>
                  <span>{item.subtitle}</span>
                </div>
                <p>{item.text}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Reviews;
